import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import './TableNewPaginanation.css'

function TableNewPaginanation({
  totalItems = 0,
  pageSize = 10,
  currentPage = 1,
  onPageChange,
  isDropdown = true,
  isPaggination = true,
}) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 480 : false
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 480);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // total pages
  const totalPages =
    pageSize === "all" ? 1 : Math.ceil(totalItems / pageSize);

  // page numbers logic
  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 6;

    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      let start = Math.max(1, currentPage - 2);
      let end = Math.min(totalPages, start + maxVisible - 1);

      if (end - start < maxVisible - 1) {
        start = Math.max(1, end - maxVisible + 1);
      }

      for (let i = start; i <= end; i++) pages.push(i);
    }
    return pages;
  };

  // Showing X to Y of Z
  const start =
    totalItems === 0
      ? 0
      : (currentPage - 1) *
          (pageSize === "all" ? totalItems : pageSize) +
        1;

  const end =
    pageSize === "all"
      ? totalItems
      : Math.min(currentPage * pageSize, totalItems);

  return (
  <div className="container-fluid custom-pagination-wrapper">
  <div className="row align-items-center w-100">


      {/* DROPDOWN + ENTRIES */}
      {isDropdown && (
<div className="col-12 col-md-auto d-flex align-items-center gap-2 mb-2 mb-md-0">

          <Dropdown
            onSelect={(value) =>
              onPageChange(
                1,
                value === "all" ? "all" : Number(value)
              )
            }
          >
         <Dropdown.Toggle className="custom-select-pagination">
              {pageSize}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item eventKey="10">10</Dropdown.Item>
              <Dropdown.Item eventKey="25">25</Dropdown.Item>
              <Dropdown.Item eventKey="50">50</Dropdown.Item>
              <Dropdown.Item eventKey="100">100</Dropdown.Item>
              <Dropdown.Item eventKey="all">All</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          <div className="entries-text">
            Showing {start} to {end} of {totalItems} entries
          </div>
        </div>
      )}

     

      {/* PAGINATION */}
     
        <div className="col-12 col-md d-flex justify-content-center justify-content-md-end">

<ul
  className={`pagination custom-pagination-list ${
    isMobile ? "pagination-sm" : "pagination-md"
  }`}
>
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button
                className="page-link"
                onClick={() => onPageChange(1)}
              >
                «
              </button>
            </li>

            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button
                className="page-link"
                onClick={() => onPageChange(currentPage - 1)}
              >
                ‹
              </button>
            </li>

            {getPageNumbers().map((page) => (
              <li
                key={page}
                className={`page-item ${
                  currentPage === page ? "active" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => onPageChange(page)}
                >
                  {page}
                </button>
              </li>
            ))}

            <li
              className={`page-item ${
                currentPage === totalPages ? "disabled" : ""
              }`}
            >
              <button
                className="page-link"
                onClick={() => onPageChange(currentPage + 1)}
              >
                ›
              </button>
            </li>

            <li
              className={`page-item ${
                currentPage === totalPages ? "disabled" : ""
              }`}
            >
              <button
                className="page-link"
                onClick={() => onPageChange(totalPages)}
              >
                »
              </button>
            </li>
          </ul>
        </div>
    </div>
     </div>
  );
}

export default TableNewPaginanation;